/**
 * Should be added to entities other than frames that you want the WallVisibilityValidation
 * to hinder from snapping to hidden walls.
 */
class WallVisibilityComponent {
    constructor() {
        this.typeId = WallVisibilityComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
WallVisibilityComponent.id = 2071;
export default WallVisibilityComponent;
//# sourceMappingURL=WallVisibilityComponent.js.map